export default {
    illiterate : 'Illiterate',
    primarySchool : 'PrimarySchool',
    middleSchool : 'MiddleSchool',
    diploma : ' Diploma',
    associate : 'Associate',
    bachelor : ' Bachelor',
    master : 'Master',
    doctoral : ' Doctoral',
    postDoctoral : 'PostDoctoral',
}